// extracted by mini-css-extract-plugin
export default {"imgD":"Image_imgD__oSsAo"};